import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Alert } from 'src/app/core/models/alert.models';
import { AlertData } from 'src/app/core/services/alert.service';

import { HEADERS } from '../api-headers';
import {
  ALERT_DELETE,
  ALERT_GET_LIST,
  ALERT_PATCH_TOGGLE_MODE,
  ALERT_POST,
  ALERT_POST_CREATE_FOR_FEED,
} from '../endpoints/alert.endpoints';
import { alertToUrlEncoded } from '../serialize/alert.serialize';
import { toQueryParams } from '../api-utils';

@Injectable({
  providedIn: 'root',
})
export class AlertApiService {
  private readonly http = inject(HttpClient);

  /** The object's alerts. `object_class_id` is FEED for every current caller. */
  listAlerts(objectClassId: number, objectId: string): Observable<Alert[]> {
    return this.http.get<Alert[]>(ALERT_GET_LIST, {
      params: toQueryParams({
        object_class_id: objectClassId,
        object_id: objectId,
      }),
    });
  }

  createAlert(feedId: string, alert: AlertData): Observable<Alert> {
    return this.http.post<Alert>(
      ALERT_POST_CREATE_FOR_FEED(feedId),
      alertToUrlEncoded(alert),
      { headers: HEADERS.formUrlEncoded },
    );
  }

  editAlert(alertId: string, alert: AlertData): Observable<Alert> {
    return this.http.post<Alert>(
      ALERT_POST(alertId),
      alertToUrlEncoded(alert),
      {
        headers: HEADERS.formUrlEncoded,
      },
    );
  }

  deleteAlert(alertId: string): Observable<unknown> {
    return this.http.delete(ALERT_DELETE(alertId), {
      headers: HEADERS.formUrlEncoded,
    });
  }

  toggleAlertMode(alertId: string): Observable<unknown> {
    return this.http.patch(ALERT_PATCH_TOGGLE_MODE(alertId), null, {
      headers: HEADERS.formUrlEncoded,
    });
  }
}
